import React, {useState, useContext, useLayoutEffect } from 'react'

//Node Modules
import {useHistory} from 'react-router-dom'
import { useTranslation } from 'react-i18next'

//Components
import * as service from 'components/Collection/service'
import { CollectionTreeExpandClosedIcon, CollectionTreeExpandOpenedIcon} from 'components/SASIcon'

//Styles
import styles from 'components/Tree/Item.module.scss'
import tocStyles from 'components/TOC/TOC.module.scss'
import TOC from 'components/TOC'

//Context
import { CollectionContext} from 'context/content-context'
import { LanguageContext } from 'context/language-context'

//Types
import { CDCInfo } from 'types/cdc'

//Util
import { keyboardClick } from 'util/tree'

export interface Props {
  alias?: string
  page: string,
  selected: boolean,
  toc: any[],
  cdcInfo?: CDCInfo,
  toggleSidebar: ()=>void,
  index: number,
  count: number
}

const CollectionItem = ({alias, page,  selected, toc, cdcInfo, toggleSidebar, index, count}: Props) => {
  const [expanded, setExpanded] = useState(selected)
  const history = useHistory()
  const { t } = useTranslation()
  const collectionContext = useContext(CollectionContext)
  const currentLanguage = useContext(LanguageContext)

useLayoutEffect(() => {
    if (!selected) {
      setExpanded(false)
    } 
  }, [selected])
 
  const handleClick = (e: React.MouseEvent) => {
    setExpanded(!expanded)
    if (!selected && collectionContext && cdcInfo?.id && cdcInfo?.version) {
      service.retrieveDefaultContext(cdcInfo?.id, cdcInfo?.version).then( value => {
        let path = `/doc/${currentLanguage}/${collectionContext.info.id}/${collectionContext.info.version}/${cdcInfo.id}/${value.docset}/${value.file}`
        history.push(path)
      })
    }
  }

  const keypressHandler = (e: React.KeyboardEvent) => {
    switch (e.keyCode) {
      case 13: //enter key
        keyboardClick()
        break;
      case 32: //spacebar
        keyboardClick()
        break;
    }
  }

  return (
    <li className={`${styles.treeitem} ${styles.collectionItem}`}>
      <div id={cdcInfo?.id} aria-controls={`${cdcInfo?.id}Id`} tabIndex={0} className={`${styles.item} ${selected && !expanded && styles.item_selected}`} onClick={handleClick} onKeyDown={keypressHandler} aria-expanded={expanded}>
        { expanded && <div className={styles.iconContainer}><CollectionTreeExpandOpenedIcon /></div> }
        { !expanded && <div className={styles.iconContainer}><CollectionTreeExpandClosedIcon /></div> }
        <span className={`${tocStyles.label} ${selected && styles.selectedText}`}>{cdcInfo?.shortTitle && cdcInfo.shortTitle.value}</span>
      </div>
      <div id={`${cdcInfo?.id}Id`} className={styles.collectionChildren} aria-labelledby={cdcInfo?.id+' '+ t('helpcenter-gui-icu.toc.tree.information.aria', {level: 1, index: index, count: count})} role="region">
        { expanded && selected && <TOC alias={alias} page={page} nodes={toc} toggleSidebar={toggleSidebar} level={2}/>}
      </div>
    </li>
  )
}

export default CollectionItem